import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Steps } from "rsuite";
import { useTranslation } from "react-i18next";
import "rsuite/dist/rsuite.min.css";
function DataImportSteps({ step }) {
    const { t } = useTranslation();
    return (_jsx(_Fragment, { children: _jsxs(Steps, { current: step, children: [_jsx(Steps.Item, { title: t("dataImport.steps.selectDataSource") }), _jsx(Steps.Item, { title: t("dataImport.steps.requestDataExport") }), _jsx(Steps.Item, { title: t("dataImport.steps.uploadData") }), _jsx(Steps.Item, { title: t("dataImport.steps.saveMetadata") })] }) }));
}
export default DataImportSteps;
